import { Button } from '../../../cdl/Button/Button';
import { Callout } from '../../../cdl/Callout/Callout';
import { translate } from '../../../common/helpers/translate.helper';

interface UnmatchedProductsCalloutProps {
    count: number;
    onReview: () => void;
}

export const UnmatchedProductsCallout = ({ count, onReview }: UnmatchedProductsCalloutProps) => {
    const headingKey =
        count === 1 ? 'vessel.products.unmatchedCallout.headingOne' : 'vessel.products.unmatchedCallout.headingOther';

    return (
        <Callout
            heading={translate(headingKey, { count: String(count) })}
            description={translate('vessel.products.unmatchedCallout.description')}
        >
            <Button emphasis="high" onClick={onReview}>
                {translate('vessel.products.unmatchedCallout.review')}
            </Button>
        </Callout>
    );
};
